var map = {
	"./attach_email_black.svg": "00f4",
	"./btn_back.svg": "7cc0",
	"./btn_back_end.svg": "6ae8",
	"./btn_calender.svg": "fc98",
	"./btn_cancel.svg": "52f4",
	"./btn_center.svg": "3afc",
	"./btn_left.svg": "1683",
	"./btn_next.svg": "9a21",
	"./btn_next_end.svg": "1241",
	"./btn_pulldown.svg": "e337",
	"./btn_right.svg": "f969",
	"./btn_search.svg": "429a",
	"./btn_sort.svg": "fe4a",
	"./btn_under.svg": "90fb",
	"./btn_upper.svg": "a8cb",
	"./credit_card_black.svg": "4d26",
	"./delete_sweep.svg": "818f",
	"./icon_btn_add.svg": "a7d9",
	"./icon_btn_cancel.svg": "a32a",
	"./icon_btn_delete.svg": "5167",
	"./icon_btn_edit.svg": "0b99",
	"./icon_btn_favorite.svg": "6540",
	"./icon_btn_reload.svg": "a0a4",
	"./icon_btn_show.svg": "bf96",
	"./icon_btn_show_right.svg": "da8c",
	"./icon_global_DepositsAndWithdrawals.svg": "b387",
	"./icon_global_buying.svg": "f469",
	"./icon_global_help.svg": "8e9b",
	"./icon_global_lang.svg": "e525",
	"./icon_global_operation.svg": "ab84",
	"./icon_global_report.svg": "afe2",
	"./icon_global_sale.svg": "bfe1",
	"./icon_global_setting.svg": "b7af",
	"./icon_global_stock.svg": "fe36",
	"./icon_global_user.svg": "a1f2",
	"./icon_menu_accountant.svg": "0cf2",
	"./icon_menu_appropriation.svg": "6cb3",
	"./icon_menu_arrival.svg": "8ea2",
	"./icon_menu_arrival_list.svg": "b2a2",
	"./icon_menu_barcode.svg": "1291",
	"./icon_menu_case.svg": "168d",
	"./icon_menu_deposit.svg": "664f",
	"./icon_menu_fav.svg": "7e78",
	"./icon_menu_inventory.svg": "9bd1",
	"./icon_menu_inventory_list.svg": "1067",
	"./icon_menu_management.svg": "7d57",
	"./icon_menu_order.svg": "0919",
	"./icon_menu_order_list.svg": "8c68",
	"./icon_menu_orders.svg": "cf92",
	"./icon_menu_orders_list.svg": "6103",
	"./icon_menu_payment_list.svg": "5a42",
	"./icon_menu_purchase_list.svg": "7572",
	"./icon_menu_request.svg": "df42",
	"./icon_menu_request_CarryForward.svg": "d137",
	"./icon_menu_request_list.svg": "4bba",
	"./icon_menu_sales.svg": "56e7",
	"./icon_menu_shipment.svg": "45c6",
	"./icon_menu_shipment_list.svg": "e7b7",
	"./icon_menu_stock.svg": "8e46",
	"./icon_menu_stock_move.svg": "9ea1",
	"./icon_menu_stock_move_list.svg": "8cc4",
	"./icon_menu_stock_plans.svg": "0a89",
	"./icon_menu_stock_transfer.svg": "3c5d",
	"./icon_menu_stock_transfer_list.svg": "2164",
	"./icon_menu_stock_unitPrice.svg": "ac20",
	"./icon_message.svg": "7f85",
	"./icon_setting.svg": "7935",
	"./icon_side_accountant.svg": "16e4",
	"./icon_side_appropriation.svg": "ef36",
	"./icon_side_arrival.svg": "0634",
	"./icon_side_arrival_list.svg": "8c92",
	"./icon_side_barcode.svg": "ae26",
	"./icon_side_case.svg": "e8d6",
	"./icon_side_deposit.svg": "0244",
	"./icon_side_fav.svg": "5beb",
	"./icon_side_favorite.svg": "d973",
	"./icon_side_history.svg": "02e9",
	"./icon_side_inventory.svg": "83d1",
	"./icon_side_inventory_list.svg": "1c8b",
	"./icon_side_news.svg": "954f",
	"./icon_side_order.svg": "477c1",
	"./icon_side_order_list.svg": "fc1d",
	"./icon_side_orders.svg": "93f4",
	"./icon_side_orders_list.svg": "a740",
	"./icon_side_payment_list.svg": "0737",
	"./icon_side_purchase_list.svg": "c326",
	"./icon_side_request.svg": "dce5",
	"./icon_side_request_CarryForward.svg": "2ceb",
	"./icon_side_request_list.svg": "bbe0",
	"./icon_side_sales.svg": "2769",
	"./icon_side_setting.svg": "55d6",
	"./icon_side_shipment.svg": "ac56",
	"./icon_side_shipment_list.svg": "e751",
	"./icon_side_stock.svg": "c881",
	"./icon_side_stock_move.svg": "cde6",
	"./icon_side_stock_move_list.svg": "1a27",
	"./icon_side_stock_plans.svg": "45b9",
	"./icon_side_stock_transfer.svg": "ee00",
	"./icon_side_stock_transfer_list.svg": "d342",
	"./icon_side_stock_unitPrice.svg": "6938",
	"./icon_side_systemlog.svg": "a69b",
	"./icon_sort.svg": "4203",
	"./icon_tool_copy.svg": "8177",
	"./icon_tool_delete.svg": "f2eb",
	"./icon_tool_disposal.svg": "383e",
	"./icon_tool_edit.svg": "9b97",
	"./icon_tool_file.svg": "b08a",
	"./icon_tool_new.svg": "6ccd",
	"./icon_tool_report.svg": "6cb1",
	"./send_black.svg": "e118"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";